import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const testSettings: Settings = {
  baseUrl: 'https://seed-insecta-api-test.se.research.vylor.com',
  environment: 'test',
  isProd: false,
  appInsightsConnectionString:
    'InstrumentationKey=c2cf9f75-09e9-4d53-9ed0-884534fa41d9;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=c06f27a4-cb21-4514-9d6d-b637bbe4bb27',
  msal: {
    config: {
      auth: {
        clientId: '018e09bd-0a75-43b8-809b-6f5cb863e5a9',
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01/',
        redirectUri: 'https://seed-insecta-test.se.research.vylor.com/after-login',
        postLogoutRedirectUri: 'https://seed-insecta-test.se.research.vylor.com/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://seed-insecta-api-test.se.research.vylor.com', ['api://018e09bd-0a75-43b8-809b-6f5cb863e5a9/API.Call']]
      ])
    }
  }
};
